import Link from "next/link";
import getConfig from "next/config";
import { connect } from "react-redux";
import { removeModal } from "@store/app/actions";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const ResealedNav = ({ categories, removeModal }) => {
  const handleClick = async () => {
    await removeModal();
  };

  return (
    <ul className="divide-y-[1px] md:border-y-[1px] md:border-gray-400 divide-gray-400 text-[16px] leading-[20px] font-medium">
      {categories.map(({ name, url_key, isActive }) => (
        <li
          key={url_key}
          className={`py-[8px] ${isActive ? "text-[#ADADAD]" : ""}`}
        >
          {isActive ? (
            <span className={isBricoStore ? "bd-claim inline-block" : ""}>
              {name}
            </span>
          ) : (
            <Link href={`/resigilate/${url_key}/cpl`}>
              <a onClick={async () => handleClick()}>
                <span className={isBricoStore ? "bd-claim inline-block" : ""}>
                  {name}
                </span>
              </a>
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default connect(null, { removeModal })(ResealedNav);
